<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-overlay
        variant="white"
        :show="loading"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
      >
        <b-card
         class="mb-0"
      >
        <b-link class="brand-logo">
          <vuexy-logo />
          <h2 class="brand-text text-primary ml-1">
            ДРП
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Вход в панель
        </b-card-title>
        <b-card-text class="mb-2">
          Зарегистрируйтесь, что начать работу
        </b-card-text>

        <!-- form -->
        <validation-observer
                ref="form"
                #default="{invalid}"
        >
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="register"
          >

            <!-- email -->
            <b-form-group
              label="Email"
              label-for="email"
              label-size="sm"
              class="flex-grow-1"
            >
              <validation-provider
                #default="{ errors }"
                name="email"
                rules="required|email"
              >
                <b-form-input
                  v-model="email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="john@example.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              label="Пароль"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                name="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                >
                  <b-form-input
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'"
                        @click="() => passwordFieldType = passwordFieldType === 'password' ? 'text' : 'password'"
                      />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
            >
              Зарегистрироваться
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>Уже зарегистрированны? </span>
          <b-link :to="{name:'auth-login'}">
            <span>Войти в аккаунт</span>
          </b-link>
        </b-card-text>
      </b-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>

  import VuexyLogo from '@core/layouts/components/Logo.vue'

  import {
    BOverlay,
    BCard, BCardTitle, BCardText,
    BForm, BFormGroup,
    BInputGroup, BFormInput, BInputGroupAppend,
    BFormCheckbox,
    BLink, BButton,
  } from 'bootstrap-vue'

  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, email } from '@validations'


  import useAuthentication from './useAuthentication'

  export default {
    components: {
      // BSV
      BButton,
      BForm,
      BFormInput,
      BFormGroup,
      BCard,
      BCardTitle,
      BLink,
      VuexyLogo,
      BCardText,
      BInputGroup,
      BInputGroupAppend,
      BFormCheckbox,

      // validations
      ValidationProvider,
      ValidationObserver,
      BOverlay
    },

    setup() {

      const {
        form,
        email,
        password,
        loading,
        register,
        passwordFieldType
      } = useAuthentication()

      return {
        form,

        email,
        password,
        loading,
        register,
        passwordFieldType
      }
    }

}
</script>

<style lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
</style>

